import React, { memo } from "react";
import { FixedSizeList as List } from "react-window";
import { Box, Stack } from "@mui/material";
import CardHosts from "./index";

const VirtualizedHosts = memo(
  ({ hosts, search, style, iconsElement }) => {
    // Define a altura de cada item (ajuste conforme necessário)
    const isScrolling = hosts.length * 100 > window.innerHeight;
    // Renderiza cada item virtualizado
    const Row = ({ index, style }) => {
      const host = hosts[index];
      return (
        <Box sx={style}>
          <CardHosts
            key={"hosts" + index}
            host={host}
            setFocusNodeId={search}
            iconsElement={iconsElement}
            isScrolling={isScrolling}
          />
        </Box>
      );
    };

    return (
      <Stack direction="column" gap={1} sx={[style, { paddingRight: "0px" }]}>
        <List
          key={Math.random()}
          height={window.innerHeight} // Altura visível do container da lista
          itemCount={hosts.length} // Total de itens na lista
          itemSize={100} // Altura de cada item
          width="100%" // Largura do container da lista
        >
          {Row}
        </List>
      </Stack>
    );
  },
  (prevProps, nextProps) => {
    return JSON.stringify(prevProps.hosts) == JSON.stringify(nextProps.hosts);
  }
);

export default VirtualizedHosts;
